import script from "./HeroPhones.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroPhones.vue?vue&type=script&setup=true&lang=js"

import "./HeroPhones.vue?vue&type=style&index=0&id=167083a9&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167083a9"]])

export default __exports__